/**
 * Normalize a colorHex string returned by the API into a valid CSS color.
 * The backend often sends hex without the leading `#` (e.g. "a7ec2e"),
 * which is invalid in CSS and silently falls back to transparent.
 *
 * Returns a `#`-prefixed hex (lowercased), or a fallback cyan if the value
 * is empty/null. Also accepts `rgb(...)`, `hsl(...)`, named colors as-is.
 */
export function rarityColor(raw?: string | null): string {
    if (!raw) return '#4cc2ff';
    const s = raw.trim();
    if (!s) return '#4cc2ff';
    // Already a valid CSS color form
    if (s.startsWith('#') || s.startsWith('rgb') || s.startsWith('hsl')) return s;
    // Bare 3 / 6 / 8 hex chars — add the missing '#'
    if (/^[0-9a-fA-F]{3}$|^[0-9a-fA-F]{6}$|^[0-9a-fA-F]{8}$/.test(s)) return `#${s}`;
    // Fallback for anything unexpected
    return '#4cc2ff';
}
